import React, { useCallback, useState } from 'react';
import { Space, Table, Input, Button } from 'antd';
import { useParams } from 'react-router-dom';
import { useRequest } from '../../../hooks';
import { getRealtimeDatas } from '../../../api/onlineDatas';
import { dateTimeRender, textRender } from '../../../utils';
import styles from './index.module.scss';
const { Column } = Table;

const Alarms: React.FC<{
    showCertain?: {
        projectId: any, deviceSn: string
    }
}> = (props) => {
    const { projectId, deviceSn: deviceSnFromParams } = useParams();
    const [searchParams, setSearchParams] = useState<Partial<OnlineDataParams>>({
        projectId: projectId ? Number(projectId) : undefined,
        devSn: deviceSnFromParams,
    });
    const fetchData = useCallback(() => {
        if (props.showCertain) {
            return getRealtimeDatas(props.showCertain)
        }
        return getRealtimeDatas(searchParams)
    }, [searchParams, props.showCertain]);

    const { data, loading } = useRequest(fetchData);
    const [deviceSn, setDeviceSn] = useState(deviceSnFromParams);
    const [alarmType, setAlarmType] = useState<string>();

    return (
        <>
            {
                props.showCertain ? null :
                    <Space>
                        <Input placeholder='请输入设备序列号' onChange={e => setDeviceSn(e.target.value)} value={deviceSn} allowClear></Input>
                        {/* <Select placeholder="请选择告警类型" allowClear value={alarmType} onChange={e => setAlarmType(e)} options={alarmTypes} /> */}
                        <Button type='primary' onClick={() => {
                            setSearchParams({
                                ...searchParams,
                                devSn: deviceSn,
                                alarmType,
                            })
                        }}>查询</Button>
                    </Space>
            }
            <br />
            <br />
            <LogTable data={data} loading={loading} />
        </>
    );
}

export const groupDataBySn = (_data?: Array<RealtimeData & { children?: RealtimeData[] }>) => {
    // 按sn分组
    const list: Array<RealtimeData & { children?: RealtimeData[] }> = _data || [];
    const data: Array<RealtimeData & { children?: RealtimeData[] }> = [];
    const deviceSns: string[] = [];
    list.forEach(i => {
        if (!deviceSns.includes(i.deviceSn)) {
            deviceSns.push(i.deviceSn)
        }
    });

    for (let sn of deviceSns) {
        const group = list.filter(i => i.deviceSn === sn).sort((a, b) => a.switchNumber - b.switchNumber)
        if (group.length === 1) data.push(group[0])
        else {
            const head = group.shift();
            head!.children = group;
            data.push(head!)
        }
    }
    return data;
}
export const LogTable = (props: { data?: RealtimeData[], loading?: boolean, pagination?: any }) => {

    const data = groupDataBySn(props.data)
    return (
        <Table className={styles.table} scroll={{ x: 1 }} dataSource={data} loading={props.loading} pagination={props.pagination}>
            <Column fixed width={150} title="展位号" dataIndex="deviceName" key="deviceName" render={textRender} />
            <Column fixed width={220} title="设备序列号" dataIndex="deviceSn" key="deviceSn" render={textRender} />
            <Column fixed width={100} title="开关号" dataIndex="switchNumber" key="switchNumber" render={textRender} />
            <Column width={100} title="容量" render={textRender} dataIndex="capacity" key="capacity" />
            <Column width={100} title="频率(分钟)" dataIndex="frequency" key="frequency" render={textRender} />
            <Column width={100} title="开关状态" dataIndex="deviceSwitchStatus" key="deviceSwitchStatus" render={
                (deviceSwitchStatus, row) => {
                    return deviceSwitchStatus === '1' ? '合闸' : '分闸'
                }
            } />
            <Column width={100} title="设备类型" dataIndex="deviceType" key="deviceType" render={textRender} />
            <Column width={100} title="电流(A)" dataIndex="switchCurrent" key="switchCurrent" render={textRender} />
            <Column width={100} title="功率(W)" dataIndex="switchPower" key="switchPower" render={textRender} />
            <Column width={100} title="电压(V)" dataIndex="switchVoltage" key="switchVoltage" render={textRender} />
            <Column width={100} title="温度(℃)" dataIndex="switchTemp" key="switchTemp" render={textRender} />
            <Column width={140} title="漏电电流(mA)" dataIndex="switchLeakage" key="switchLeakage" render={textRender} />
            <Column width={120} title="A相电流(A)" dataIndex="switchCurrentA" key="switchCurrentA" render={textRender} />
            <Column width={120} title="B相电流(A)" dataIndex="switchCurrentB" key="switchCurrentB" render={textRender} />
            <Column width={120} title="C相电流(A)" dataIndex="switchCurrentC" key="switchCurrentC" render={textRender} />
            <Column width={120} title="N相电流(A)" dataIndex="switchCurrentN" key="switchCurrentN" render={textRender} />
            <Column width={120} title="A相电压(V)" dataIndex="switchVoltageA" key="switchVoltageA" render={textRender} />
            <Column width={120} title="B相电压(V)" dataIndex="switchVoltageB" key="switchVoltageB" render={textRender} />
            <Column width={120} title="C相电压(V)" dataIndex="switchVoltageC" key="switchVoltageC" render={textRender} />
            <Column width={200} title="接收时间" sorter dataIndex="receiveDatetime" key="receiveDatetime" render={dateTimeRender} />
        </Table>
    )
}

export default Alarms;